export const sushi = {
  seo: {
    title: 'Case: De Wethouder Food & Drink Club | Bistroo',
    description: 'Lees hoe De Wethouder Food & Drink Club een betrouwbare online partner vond in Bistroo.',
  },
  hero: {
    title: 'Lees hoe de Wethouder een betrouwbare online partner vond in Bistroo',
    description:
      'De Wethouder Food & Drink Club is een trendy establishment gevestigd in het voormalige gemeentehuis van Denekamp. Ze bieden een gevarieerd en wisselend menu aan, met als hoogtepunt het unieke walking diner concept.',
  },
  testimonials: {
    1: {
      text: '"Met Bistroo\'s besteloplossing konden we bestellingen nauwkeurig verwerken en de afhandeling ervan beheren. Dit leidde tot minder fouten en een verbeterde klanttevredenheid"',
      name: 'Ben Schulte',
      job_title: 'Chef',
    },
    2: {
      text: '"Het gebruik van Bistroo voor de verkoop van sushi to go bleek bijzonder succesvol en efficiënt te zijn, wat heeft bijgedragen aan een betere service en een verbeterde klantervaring. Dit hadden we anders nooit geweten!"',
      name: 'Edwin ter Haar',
      job_title: 'Operationeel verantwoordelijk',
    },
  },
  challenge: {
    paragraph: {
      title: 'Duurzame samenwerking',
      text: 'Naast hun dine-in ervaring, bieden ze ook sushi to go aan, een populair aanbod dat via Bistroo wordt verkocht. De Wethouder werkt al ruim 2 jaar samen met Bistroo en vertelt kort over de uitdagingen die ze hadden vóór de samenwerking en de oplossingen die Bistroo biedt.',
    },
    paragraph_2: {
      title: 'De uitdaging',
      bullets: {
        1: 'Tijdens piekuren werd De Wethouder Food & Drink Club overspoeld met bestellingen, waardoor het personeel overbelast raakte en klanten langer moesten wachten.',
        2: 'Het beheren van bestellingen en de afhandeling ervan was een uitdaging, met name tijdens drukke tijden.',
        3: 'Het was van cruciaal belang om ervoor te zorgen dat bestellingen nauwkeurig werden verwerkt om fouten te minimaliseren en klanttevredenheid te waarborgen.',
      },
    },
  },
  solution: {
    title: 'De oplossing',
    checklist: {
      1: "Dankzij Bistroo's online besteloplossing kon De Wethouder Food & Drink Club hun sushi to go-aanbod eenvoudig en efficiënt beheren. Klanten konden gemakkelijk online bestellen en afhalen, waardoor het proces werd gestroomlijnd.",
      2: "Met Bistroo's besteloplossing kon De Wethouder | Food & Drink Club bestellingen nauwkeurig verwerken en de afhandeling ervan beheren. Dit leidde tot minder fouten en een verbeterde klanttevredenheid.",
      3: 'Bistroo bood De Wethouder | Food & Drink Club flexibiliteit en aanpassingsvermogen, waardoor ze snel konden inspelen op veranderende behoeften en nieuwe mogelijkheden, zoals de verkoop van sushi to go.',
    },
  },
  conclusion: {
    title: 'Conclusie',
    text: {
      1: "Dankzij Bistroo's Online Besteloplossing kon De Wethouder Food & Drink Club niet alleen hun operationele efficiëntie verbeteren, maar ook hun klanttevredenheid verhogen en groeimogelijkheden benutten. Het gebruik van Bistroo voor de verkoop van sushi to go bleek bijzonder succesvol en efficiënt te zijn, wat heeft bijgedragen aan een betere service en een verbeterde klantervaring. Bistroo onderscheidt zich door zijn Twentse gastvrijheid, waarbij het actief meedenkt in oplossingen en nieuwe mogelijkheden voor De Wethouder Food & Drink Club. Deze lokale aanpak creëert een sterke vertrouwensband en versterkt de samenwerking tussen beide partijen.",
      2: 'Bovendien staat Bistroo 24/7 klaar om De Wethouder Food & Drink Club te ondersteunen, ongeacht het tijdstip. Deze continue ondersteuning geeft het restaurant gemoedsrust en vertrouwen in hun online bestelproces. De Wethouder | Food & Drink Club raadt Bistroo ten zeerste aan aan andere horecabedrijven die op zoek zijn naar een flexibele en efficiënte online besteloplossing.',
    },
  },
}
